import React from 'react';
import { oohData } from '../utils/oohData';
import { TargetIcon, BuildingIcon, UsersIcon, MessageCircleIcon, TagIcon, FileTextIcon } from 'lucide-react';
export const CreativeContext: React.FC = () => {
  const {
    brandContext
  } = oohData;
  return <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-40">
      <h2 className="text-lg font-medium text-gray-800 mb-6" data-id="element-41">
        Creative Preview & Brand Context
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-42">
        {/* Left Column: Creative Preview */}
        <div className="space-y-4" data-id="element-43">
          <div className="relative rounded-xl overflow-hidden border border-gray-100 shadow-sm" data-id="element-44">
            <img src={brandContext.imageUrl} alt="OOH Creative" className="w-full h-auto object-cover" data-id="element-45" />
            <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm flex items-center space-x-2" data-id="element-46">
              <TargetIcon className="w-4 h-4 text-[#1E90FF]" data-id="element-47" />
              <span className="export-text-up text-xs font-semibold text-gray-800 uppercase tracking-wider" data-id="element-48">
                {brandContext.oohObjective}
              </span>
            </div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-49">
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-50">
              Objective Rationale
            </h4>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-51">
              {brandContext.objectiveRationale}
            </p>
          </div>
        </div>

        {/* Right Column: Brand Context Data */}
        <div className="space-y-6" data-id="element-52">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-53">
            <div data-id="element-54">
              <div className="flex items-center space-x-2 mb-1" data-id="element-55">
                <BuildingIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-56" />
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-57">
                  Brand
                </span>
              </div>
              <p className="text-sm font-medium text-gray-900" data-id="element-58">
                {brandContext.brandName}
              </p>
            </div>

            <div data-id="element-59">
              <div className="flex items-center space-x-2 mb-1" data-id="element-60">
                <TagIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-61" />
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-62">
                  Industry
                </span>
              </div>
              <p className="text-sm font-medium text-gray-900" data-id="element-63">
                {brandContext.industry}
              </p>
            </div>

            <div data-id="element-64">
              <div className="flex items-center space-x-2 mb-1" data-id="element-65">
                <TargetIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-66" />
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-67">
                  Market Segment
                </span>
              </div>
              <p className="text-sm font-medium text-gray-900" data-id="element-68">
                {brandContext.marketSegment}
              </p>
            </div>

            <div data-id="element-69">
              <div className="flex items-center space-x-2 mb-1" data-id="element-70">
                <MessageCircleIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-71" />
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-72">
                  Brand Tone
                </span>
              </div>
              <p className="text-sm font-medium text-gray-900" data-id="element-73">
                {brandContext.brandTone}
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-gray-100" data-id="element-74">
            <div className="flex items-center space-x-2 mb-2" data-id="element-75">
              <UsersIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-76" />
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-77">
                Target Audience
              </span>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-78">
              {brandContext.targetAudience}
            </p>
          </div>

          <div className="pt-4 border-t border-gray-100" data-id="element-79">
            <div className="flex items-center space-x-2 mb-2" data-id="element-80">
              <FileTextIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-81" />
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-82">
                Creative Summary
              </span>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-83">
              {brandContext.creativeSummary}
            </p>
          </div>
        </div>
      </div>
    </div>;
};